/**
 * Dropdown hiding the profile links and the logout button of the visitor.
 */

import { query, queryAll } from "../core/dom";

const OPEN_CLASS = "is-open";

/** Open or close the panel of a single user menu. */
export function setMenuOpen(menu: HTMLElement, open: boolean): void {
    const toggle = query<HTMLElement>("[data-user-menu-toggle]", menu);
    const panel = query<HTMLElement>("[data-user-menu-panel]", menu);

    menu.classList.toggle(OPEN_CLASS, open);
    toggle?.setAttribute("aria-expanded", open ? "true" : "false");

    if (panel) {
        panel.hidden = !open;
    }
}

/** Close every user menu of the page. */
export function closeAllMenus(): void {
    for (const menu of queryAll<HTMLElement>("[data-user-menu]")) {
        setMenuOpen(menu, false);
    }
}

/** Wire every user menu present on the page. */
export function initUserMenu(): void {
    const menus = queryAll<HTMLElement>("[data-user-menu]");
    if (menus.length === 0) {
        return;
    }

    for (const menu of menus) {
        const toggle = query<HTMLElement>("[data-user-menu-toggle]", menu);
        if (!toggle) {
            continue;
        }

        setMenuOpen(menu, false);

        toggle.addEventListener("click", (event: Event) => {
            event.preventDefault();
            event.stopPropagation();

            const open = !menu.classList.contains(OPEN_CLASS);
            closeAllMenus();
            setMenuOpen(menu, open);
        });
    }

    document.addEventListener("click", (event: Event) => {
        const target = event.target;
        if (target instanceof HTMLElement && target.closest("[data-user-menu]")) {
            return;
        }

        closeAllMenus();
    });

    document.addEventListener("keydown", (event: KeyboardEvent) => {
        if (event.key !== "Escape") {
            return;
        }

        // Escape inside the panel would otherwise leave the focus nowhere.
        const open = queryAll<HTMLElement>("[data-user-menu]").find((menu) => menu.classList.contains(OPEN_CLASS));
        closeAllMenus();

        if (open) {
            query<HTMLElement>("[data-user-menu-toggle]", open)?.focus();
        }
    });
}
